import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, withKeys as _withKeys, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-c39a4376"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-nav-top" }
const _hoisted_2 = { class: "mobile-nav-top-header" }
const _hoisted_3 = ["alt"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["aria-label"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-layer-group mr-1" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-user mr-1" }, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket mr-1" }, null, -1))
const _hoisted_11 = ["href"]
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt" }, null, -1))
const _hoisted_15 = ["href"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ArtWorkSearch = _resolveComponent("ArtWorkSearch")!
  const _component_IsNotAuthenticated = _resolveComponent("IsNotAuthenticated")!
  const _component_IsAuthenticated = _resolveComponent("IsAuthenticated")!
  const _directive_tab_index = _resolveDirective("tab-index")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    onKeydown: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["esc"])),
    "data-testid-popup": "",
    class: "mobile-nav",
    ref: "popup",
    style: _normalizeStyle({ maxHeight: _ctx.closed ? '0px' : _ctx.popupHeight + 'px' })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          onClick: _ctx.close,
          to: "/",
          "aria-label": _ctx.$t('general.logo')
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: _imports_0,
              alt: _ctx.$t('general.logo'),
              class: "header-logo"
            }, null, 8, _hoisted_3)
          ]),
          _: 1
        }, 8, ["onClick", "aria-label"])), [
          [_directive_tab_index, !_ctx.closed]
        ]),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          "data-testid-times": "",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
          onKeydown: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)), ["enter"])),
          "aria-label": _ctx.$t('general.close'),
          ref: "close",
          role: "button"
        }, _hoisted_6, 40, _hoisted_4)), [
          [_directive_tab_index, !_ctx.closed]
        ])
      ]),
      _createElementVNode("nav", {
        class: "mobile-nav-top-content",
        "aria-label": _ctx.$t('navigation.mobile')
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          class: "mobile-nav-artwork",
          onClick: _ctx.close,
          to: { path: '/search', query: { lang: _ctx.locale, page: '1' } }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ArtWorkSearch)
          ]),
          _: 1
        }, 8, ["onClick", "to"])), [
          [_directive_tab_index, !_ctx.closed]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          onClick: _ctx.close,
          to: "/artists"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("navigation.artists")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_tab_index, !_ctx.closed]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          onClick: _ctx.close,
          to: "/themes"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("navigation.themes")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_tab_index, !_ctx.closed]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          onClick: _ctx.close,
          to: "/acquisitions"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("navigation.acquisitions")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_tab_index, !_ctx.closed]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          onClick: _ctx.close,
          to: "/exhibitions"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("navigation.exhibitions")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_tab_index, !_ctx.closed]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          onClick: _ctx.close,
          to: "/about-collections"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("navigation.about-collections")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_tab_index, !_ctx.closed]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_router_link, {
          onClick: _ctx.close,
          to: "/my-collections"
        }, {
          default: _withCtx(() => [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("navigation.my-collections")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [_directive_tab_index, !_ctx.closed]
        ]),
        _createVNode(_component_IsNotAuthenticated, null, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              onClick: _ctx.close,
              to: { name: 'LandingPage', query: { view: 'login' } }
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("navigation.log-in")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])), [
              [_directive_tab_index, !_ctx.closed]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_IsAuthenticated, null, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createBlock(_component_router_link, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => {
                            _ctx.logout();
                            _ctx.close();
                        }),
              to: { name: 'LandingPage' }
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("navigation.logout")), 1)
              ]),
              _: 1
            })), [
              [_directive_tab_index, !_ctx.closed]
            ])
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createElementBlock("a", {
          href: _ctx.$t('navigation.visit-url'),
          target: "_blank",
          rel: "noopener noreferrer"
        }, [
          _createTextVNode(_toDisplayString(_ctx.$t("navigation.visit-kunsten")), 1)
        ], 8, _hoisted_11)), [
          [_directive_tab_index, !_ctx.closed]
        ])
      ], 8, _hoisted_7)
    ]),
    _createElementVNode("div", {
      role: "navigation",
      "aria-label": _ctx.$t('footer.contact-data'),
      class: "mobile-nav-bottom"
    }, [
      _withDirectives((_openBlock(), _createElementBlock("a", {
        "data-testid-phone": "",
        href: 'tel:' + _ctx.$t('footer.contact.phone').replace(/ /g, '')
      }, [
        _hoisted_14,
        _createTextVNode(_toDisplayString(_ctx.$t("footer.contact.phone")), 1)
      ], 8, _hoisted_13)), [
        [_directive_tab_index, !_ctx.closed]
      ]),
      _withDirectives((_openBlock(), _createElementBlock("a", {
        "data-testid-mail": "",
        href: 'mailto:' + _ctx.$t('footer.contact.email')
      }, [
        _hoisted_16,
        _createTextVNode(_toDisplayString(_ctx.$t("footer.contact.email")), 1)
      ], 8, _hoisted_15)), [
        [_directive_tab_index, !_ctx.closed]
      ])
    ], 8, _hoisted_12)
  ], 36)), [
    [_directive_tab_index, !_ctx.closed]
  ])
}